import * as React from "react";
const SvgFiBrandsFoursquare = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#151A2D"
      d="M6.009 4.344h4.514v.741H6.758V7.16h3.347V7.9H6.758v3h-.749zM5.878 17.3l.732-.166a1.62 1.62 0 0 0 1.778 1.447c.915 0 1.638-.427 1.638-1.124 0-.5-.366-.915-1.795-1.342-1.62-.459-2.16-1.052-2.16-1.923 0-1.124.905-1.726 2.221-1.726a2.13 2.13 0 0 1 2.353 1.778l-.732.166a1.467 1.467 0 0 0-1.647-1.2c-.837 0-1.429.314-1.429.915 0 .488.383.863 1.708 1.281 1.577.488 2.257 1.02 2.257 2.031 0 1.254-1.055 1.908-2.4 1.908A2.3 2.3 0 0 1 5.878 17.3M11.7 15.917a3.221 3.221 0 0 1 5.57-2.426 3.22 3.22 0 0 1 .853 2.426 3.6 3.6 0 0 1-.863 2.414c.262.262.514.523.767.8l-.54.523a42 42 0 0 0-.8-.828 3.249 3.249 0 0 1-4.987-2.909m4.419 2.353a20 20 0 0 0-.767-.706l.523-.53c.278.243.557.5.819.748a2.9 2.9 0 0 0 .627-1.874 2.415 2.415 0 0 0-3.39-2.49 2.42 2.42 0 0 0-1.41 2.49 2.466 2.466 0 0 0 2.4 2.685c.422.009.838-.103 1.198-.323"
    />
  </svg>
);
export default SvgFiBrandsFoursquare;
